import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template"]
  static values = { open: Boolean }

  connect() {
    this.modalElement = null
    this.boundClose = this.close.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
  }

  open() {
    if (this.modalElement) return

    // Clone template and append to body
    const template = this.templateTarget
    this.modalElement = template.content.cloneNode(true).firstElementChild
    document.body.appendChild(this.modalElement)

    // Reinitialize Lucide icons in the modal
    if (window.lucide) {
      window.lucide.createIcons()
    }

    // Add event listeners for closing
    // Close on backdrop click
    const backdrop = this.modalElement.querySelector('[data-action*="modal#close"]')
    if (backdrop) {
      backdrop.addEventListener('click', this.boundClose)
    }

    // Close on X button and Cancel button clicks
    this.modalElement.querySelectorAll('button[data-action*="modal#close"]').forEach(btn => {
      btn.addEventListener('click', this.boundClose)
    })

    // Close on Escape key
    document.addEventListener('keydown', this.boundHandleKeydown)

    // Prevent body scroll
    document.body.classList.add("overflow-hidden")
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  close() {
    if (this.modalElement) {
      document.removeEventListener('keydown', this.boundHandleKeydown)
      this.modalElement.remove()
      this.modalElement = null
      document.body.classList.remove("overflow-hidden")
    }
  }

  disconnect() {
    this.close()
  }
}
